var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "panel panel-primary bl-token",
      attrs: { id: _vm.model.id },
    },
    [
      _c("div", { staticClass: "panel-heading" }, [
        _vm.canMoveLeft
          ? _c(
              "button",
              {
                staticClass: "btn btn-xs btn-default",
                attrs: {
                  type: "button",
                  title: _vm
                    .$t(
                      "search.advanced.queryBuilder.token_head_move_left_title"
                    )
                    .toString(),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("move-token-left", _vm.model.id)
                  },
                },
              },
              [_c("span", { staticClass: "glyphicon glyphicon-chevron-left" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.canMoveRight
          ? _c(
              "button",
              {
                staticClass: "btn btn-xs btn-default",
                attrs: {
                  type: "button",
                  title: _vm
                    .$t(
                      "search.advanced.queryBuilder.token_head_move_right_title"
                    )
                    .toString(),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("move-token-right", _vm.model.id)
                  },
                },
              },
              [_c("span", { staticClass: "glyphicon glyphicon-chevron-right" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bl-token-cql-preview",
            attrs: { id: _vm.model.id + "_cql_preview" },
          },
          [_vm._v(_vm._s(_vm.tokenCql))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "area-label": "delete",
              title: _vm
                .$t(
                  "search.advanced.queryBuilder.token_head_deleteButton_title"
                )
                .toString(),
            },
            on: {
              click: function ($event) {
                return _vm.$emit("delete-token", _vm.model.id)
              },
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel-body",
          attrs: { id: _vm.model.id + "_panel_body" },
        },
        [
          _c("ul", { staticClass: "nav nav-tabs" }, [
            _c("li", { class: { active: _vm.activeTab === "attributes" } }, [
              _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "attributes"
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "search.advanced.queryBuilder.body_tab_header_search"
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: { active: _vm.activeTab === "properties" } }, [
              _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "properties"
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "search.advanced.queryBuilder.body_tab_header_properties"
                      )
                    )
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _c(
              "div",
              {
                staticClass: "tab-pane",
                class: { active: _vm.activeTab === "attributes" },
                staticStyle: { padding: "15px" },
                attrs: { id: _vm.model.id + "_tab_attributes" },
              },
              [
                _c("CqlAttributeGroup", {
                  attrs: { "is-root": true, options: _vm.options },
                  on: { "update:group": _vm.updateRootAttributeGroup },
                  model: {
                    value: _vm.model.rootAttributeGroup,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "rootAttributeGroup", $$v)
                    },
                    expression: "model.rootAttributeGroup",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-pane",
                class: { active: _vm.activeTab === "properties" },
                staticStyle: { padding: "15px" },
                attrs: { id: _vm.model.id + "_tab_properties" },
              },
              [
                _c("div", { staticClass: "checkbox" }, [
                  _c(
                    "label",
                    {
                      attrs: {
                        title: _vm
                          .$t(
                            "search.advanced.queryBuilder.body_tab_properties_optional_title"
                          )
                          .toString(),
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.properties.optional,
                            expression: "model.properties.optional",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: _vm.model.id + "_property_optional",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.model.properties.optional)
                            ? _vm._i(_vm.model.properties.optional, null) > -1
                            : _vm.model.properties.optional,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.model.properties.optional,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "optional",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "optional",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.model.properties, "optional", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "search.advanced.queryBuilder.body_tab_properties_optional"
                            )
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox" }, [
                  _c(
                    "label",
                    {
                      attrs: {
                        title: _vm
                          .$t(
                            "search.advanced.queryBuilder.body_tab_properties_beginOfSentence_title"
                          )
                          .toString(),
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.properties.beginOfSentence,
                            expression: "model.properties.beginOfSentence",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: _vm.model.id + "_property_sentence_start",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.model.properties.beginOfSentence
                          )
                            ? _vm._i(
                                _vm.model.properties.beginOfSentence,
                                null
                              ) > -1
                            : _vm.model.properties.beginOfSentence,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.model.properties.beginOfSentence,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "beginOfSentence",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "beginOfSentence",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.model.properties,
                                "beginOfSentence",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "search.advanced.queryBuilder.body_tab_properties_beginOfSentence"
                            )
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox" }, [
                  _c(
                    "label",
                    {
                      attrs: {
                        title: _vm
                          .$t(
                            "search.advanced.queryBuilder.body_tab_properties_endOfSentence_title"
                          )
                          .toString(),
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.properties.endOfSentence,
                            expression: "model.properties.endOfSentence",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: _vm.model.id + "_property_sentence_end",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.model.properties.endOfSentence
                          )
                            ? _vm._i(_vm.model.properties.endOfSentence, null) >
                              -1
                            : _vm.model.properties.endOfSentence,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.model.properties.endOfSentence,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "endOfSentence",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.model.properties,
                                    "endOfSentence",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.model.properties,
                                "endOfSentence",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "search.advanced.queryBuilder.body_tab_properties_endOfSentence"
                            )
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-group",
                    staticStyle: { width: "318px" },
                  },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "search.advanced.queryBuilder.body_tab_properties_repeats_label"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.model.properties.minRepeats,
                          expression: "model.properties.minRepeats",
                          modifiers: { number: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: _vm.model.id + "_property_repeats_min",
                      },
                      domProps: { value: _vm.model.properties.minRepeats },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.model.properties,
                            "minRepeats",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "input-group-addon",
                        staticStyle: {
                          "border-left-width": "0px",
                          "border-right-width": "0px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "search.advanced.queryBuilder.body_tab_properties_repeats_to"
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.model.properties.maxRepeats,
                          expression: "model.properties.maxRepeats",
                          modifiers: { number: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: _vm.model.id + "_property_repeats_max",
                      },
                      domProps: { value: _vm.model.properties.maxRepeats },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.model.properties,
                            "maxRepeats",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "search.advanced.queryBuilder.body_tab_properties_repeats_times"
                          )
                        )
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }